import Intl from 'lean-intl';
globalThis.global = globalThis;
(globalThis as unknown as { Intl: typeof Intl }).Intl = Intl;
